const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  phone: state => state.user.phone,
  email: state => state.user.email,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.asyncRoutes,
  errorLogs: state => state.errorLog.logs,
  firstLogin: state => state.user.firstLogin,
  asyncRoutes: state => state.permission.asyncRoutes,
  isProListView: state => state.permission.isProListView,
  roleName: state => state.user.roleName,
  isAdmin: state => state.user.isAdmin,
  routerRoles: state => state.user.routerRoles,
  isManager: state => state.user.isManager,
  file_name: state => state.export_file.file_name,
  file_type: state => state.export_file.file_type
}
export default getters
